export enum WIDGET_TRAINING_LIST {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=804361128
     */
    SECTION_TITLE = 'WIDGET_TRAINING_LIST.SECTION_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=807942452
     */
    TRAININGS_LIST_WIDGET_SETTINGS_TITLE = 'WIDGET_TRAINING_LIST.TRAININGS_LIST_WIDGET_SETTINGS_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=807961270
     */
    WRITER_MODE_EMPTY_STATE_TITLE = 'WIDGET_TRAINING_LIST.WRITER_MODE_EMPTY_STATE_TITLE',
}
